import { Component, inject } from '@angular/core';
import { ISidebarNavItem } from './sidebar.interface';
import { NavSidebar } from '../nav-sidebar/nav-sidebar';
import { IconSvg } from '../icon-svg/icon-svg';
import { KeycloakService } from '../../services/keycloak.service';

@Component({
  selector: 'app-sidebar',
  imports: [NavSidebar, IconSvg],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.css'
})
export class Sidebar {
  private keycloakService = inject(KeycloakService);

  protected navItemsData: ISidebarNavItem[] = [
    {
      id: 1,
      name: 'Tableau de bord',
      iconName: 'dashboard',
      pagePath: '/tableau-de-bord'
    }, {
      id: 2,
      name: 'Prestataires',
      iconName: 'users',
      pagePath: '/prestataires'
    },
  ];

  protected settingItemsData: ISidebarNavItem[] = [
    {
      id: 3,
      name: 'Paramètre',
      iconName: 'parameter',
      pagePath: '/parametre'
    }, {
      id: 4,
      name: 'Support',
      iconName: 'support',
      pagePath: '/support'
    },
  ];

  protected logout(): void {
    this.keycloakService.logout();
  }
}
